/**
 * Textos do resumo lateral do agendamento público (CAD-31).
 *
 * - O total ganha "A partir de" quando algum serviço escolhido tem preço
 *   inicial, como no card do serviço. Antes o resumo mostrava um valor fechado.
 * - Com um profissional escolhido, o subtítulo não fala em "Equipe
 *   especializada": isso só faz sentido quando qualquer um pode atender.
 */

type SummaryService = {
  showPrice?: boolean;
  price?: number | null;
  priceStartingFrom?: boolean;
};

export function buildBookingSummaryPriceLabel<T extends SummaryService>(
  services: T[],
  getDisplayedPrice: (service: T) => number | null
): string {
  let total = 0;
  let startingFrom = false;
  for (const service of services) {
    const price = getDisplayedPrice(service);
    if (typeof price !== "number" || !Number.isFinite(price)) continue;
    total += price;
    if (service.priceStartingFrom) startingFrom = true;
  }
  if (total <= 0) return "Valor no atendimento";
  const formatted = total.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
  return startingFrom ? `A partir de ${formatted}` : formatted;
}

export function getBookingSummaryProviderSubtitle(hasChosenProvider: boolean): string {
  return hasChosenProvider ? "Profissional escolhido" : "Equipe especializada";
}
